import request from '@/libs/request'

// 牛品种 列表
export function cattleVarietyListApi (data) {
  return request({
    url: `cattleFarm/cattleVariety`,
    method: 'get',
    params: data
  })
}

// 牛品种 详情
export function cattleVarietyDetailApi (id) {
  return request({
    url: `cattleFarm/cattleVariety/` + id,
    method: 'get'
  })
}


// 牛品种 编辑/添加
export function cattleVarietySaveApi (data) {
  return request({
    url: `cattleFarm/cattleVariety`,
    method: 'post',
    data: data
  })
}

// 牛品种 删除
export function cattleVarietyDelApi (id) {
  return request({
    url: `cattleFarm/cattleVariety/` + id,
    method: 'delete'
  })
}

// 牛品种 所有数据
export function cattleVarietyAllApi () {
  return request({
    url: `cattleFarm/cattleVarietyApi/all`,
    method: 'get'
  })
}


